import createIcon from '../../createIcon';

/**
 * @component @name Summarize
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgM0g1QzMuOSAzIDMuMDEgMy45IDMuMDEgNUwzIDE5QzMgMjAuMSAzLjg5IDIxIDQuOTkgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjlMMTUgM1pNOCAxN0M3LjQ1IDE3IDcgMTYuNTUgNyAxNkM3IDE1LjQ1IDcuNDUgMTUgOCAxNUM4LjU1IDE1IDkgMTUuNDUgOSAxNkM5IDE2LjU1IDguNTUgMTcgOCAxN1pNOCAxM0M3LjQ1IDEzIDcgMTIuNTUgNyAxMkM3IDExLjQ1IDcuNDUgMTEgOCAxMUM4LjU1IDExIDkgMTEuNDUgOSAxMkM5IDEyLjU1IDguNTUgMTMgOCAxM1pNOCA5QzcuNDUgOSA3IDguNTUgNyA4QzcgNy40NSA3LjQ1IDcgOCA3QzguNTUgNyA5IDcuNDUgOSA4QzkgOC41NSA4LjU1IDkgOCA5Wk0xNCAxMFY0LjVMMTkuNSAxMEgxNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Summarize = createIcon('Summarize', [
  [
    'path',
    {
      d: 'M15 3H5C3.9 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 4.99 21H19C20.1 21 21 20.1 21 19V9L15 3ZM8 17C7.45 17 7 16.55 7 16C7 15.45 7.45 15 8 15C8.55 15 9 15.45 9 16C9 16.55 8.55 17 8 17ZM8 13C7.45 13 7 12.55 7 12C7 11.45 7.45 11 8 11C8.55 11 9 11.45 9 12C9 12.55 8.55 13 8 13ZM8 9C7.45 9 7 8.55 7 8C7 7.45 7.45 7 8 7C8.55 7 9 7.45 9 8C9 8.55 8.55 9 8 9ZM14 10V4.5L19.5 10H14Z',
      key: 'umndnb',
    },
  ],
]);

export default Summarize;
